import { MvnCodeInitiate } from "../../lib/const";
import { MvnCodeFE } from "../const";

export const SAFETY_SIGNAL_DETECTION_LANG: {
  SAFETY_SIGNAL_DETECTION_NEW_PROFILE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_CREATE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_STATUS_ACTIVE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_STATUS_INACTIVE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_COLUMN_NAME: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_COLUMN_TARGET_SCOPE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_COLUMN_STATUS: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_COLUMN_RUN_FREQUENCY: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_COLUMN_LAST_RUN: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_COLUMN_NEXT_RUN: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_EMPTY_TITLE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_EMPTY_DESCRIPTION: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_EMPTY_SEARCH_TITLE: MvnCodeFE;

  SAFETY_SIGNAL_DETECTION_EDIT_PROFILE: MvnCodeFE;

  SAFETY_SIGNAL_DETECTION_PROFILE_CREATE_SUCC: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_CREATE_FAIL: MvnCodeFE;

  SAFETY_SIGNAL_DETECTION_PROFILE_UPDATE_SUCC: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_UPDATE_FAIL: MvnCodeFE;

  SAFETY_SIGNAL_DETECTION_PROFILE_DELETE_ALERT_TITLE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_DELETE_ALERT_DESCRIPTION: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_DELETE_SUCC: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_DELETE_FAIL: MvnCodeFE;

  SAFETY_SIGNAL_DETECTION_PROFILE_INFO_TITLE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_ACTIVATION_LABEL: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_ACTIVATION_ACTIVE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_ACTIVATION_INACTIVE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_NAME_LABEL: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_NAME_PLACEHOLDER: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_COMMENT_LABEL: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_COMMENT_PLACEHOLDER: MvnCodeFE;

  SAFETY_SIGNAL_DETECTION_SIGNAL_PREFIX_LABEL: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_PREFIX_PLACEHOLDER: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_PREFIX_INFO_TOOLTIP: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_PREFIX_EXAMPLE_LABEL: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_PREFIX_EXAMPLE_FORMAT: MvnCodeFE;

  SAFETY_SIGNAL_DETECTION_EXECUTION_START_MONTH_LABEL: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_EXECUTION_START_MONTH_PLACEHOLDER: MvnCodeFE;

  SAFETY_SIGNAL_DETECTION_TARGET_SCOPE_TITLE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_INTERACTION_DRUGS_LABEL: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_INTERACTION_DRUGS_INCLUDE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_TARGET_SCOPE_LABEL: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_TARGET_SCOPE_PLACEHOLDER: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_TARGET_PRODUCT_REQUIRED: MvnCodeFE;

  SAFETY_SIGNAL_DETECTION_PROFILE_EXECUTION_TITLE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_EXECUTION_FREQUENCY_LABEL: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_EXECUTION_FREQUENCY_PLACEHOLDER: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_EXECUTION_DATE_LABEL: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_EXECUTION_DATE_PLACEHOLDER: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_EXECUTION_TIME_LABEL: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_EXECUTION_TIME_PLACEHOLDER: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_EXECUTION_SPECIFIC_DATE_LABEL: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_EXECUTION_SPECIFIC_DAY_LABEL: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_EXECUTION_DAY_PLACEHOLDER: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_EXECUTION_DAY_31_HELPER: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_EXECUTION_AD_HOC_HELPER: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_EXECUTION_START_MONTH_REQUIRED_ERROR: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_EXECUTION_START_MONTH_INVALID_ERROR: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_EXECUTION_TIME_REQUIRED_ERROR: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_EXECUTION_NEXT_RUN_DATE: MvnCodeFE;

  SAFETY_SIGNAL_DETECTION_RUN_FREQUENCY_MONTHLY: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_RUN_FREQUENCY_QUARTERLY: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_RUN_FREQUENCY_ADHOC: MvnCodeFE;

  SAFETY_SIGNAL_DETECTION_RUN_DATE_MONTHLY_FIRST: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_RUN_DATE_MONTHLY_LAST: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_RUN_DATE_SPECIFIC: MvnCodeFE;

  SAFETY_SIGNAL_DETECTION_RUN_DATE_QUARTERLY_FIRST: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_RUN_DATE_QUARTERLY_LAST: MvnCodeFE;

  SAFETY_SIGNAL_DETECTION_STATISTICAL_METHOD_TITLE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_STATISTICAL_METHOD_LABEL: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_CRITERIA_LABEL: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_MIN_REPORT_COUNT_LABEL: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_MIN_PRR_LABEL: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_MIN_ROR_LABEL: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_CHI_SQUARE_LABEL: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_CUSTOMIZED_CRITERIA_LABEL: MvnCodeFE;

  SAFETY_SIGNAL_DETECTION_PROFILE_DETAIL_CLOSE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_SETTINGS_TAB: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_EXECUTION_HISTORY_TAB: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_EXECUTION_HISTORY_EMPTY: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_EXECUTED_INFO: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_LOAD_FAIL: MvnCodeFE;

  SAFETY_SIGNAL_DETECTION_RUN_HISTORY_COL_RUN_DATE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_RUN_HISTORY_COL_RUN_METHOD: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_RUN_HISTORY_COL_RESULT: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_RUN_HISTORY_COL_SIGNAL_COUNT: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_RUN_HISTORY_STATUS_IN_PROGRESS: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_RUN_HISTORY_STATUS_SUCCESS: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_RUN_HISTORY_STATUS_FAIL: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_RUN_HISTORY_STATUS_WAITING: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_RUN_HISTORY_VIEW_RESULT: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_RUN_HISTORY_FAILED_MESSAGE: MvnCodeFE;

  SAFETY_SIGNAL_DETECTION_PROFILE_DETAIL_TARGET_SCOPE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_DETAIL_FREQUENCY: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_DETAIL_STATISTICAL_METHOD: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_DETAIL_CRITERIA: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_DETAIL_RUN_BUTTON: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_RUN_NOW_SUCCESS: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_RUN_NOW_FAIL: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_RUN_NOW_COOLDOWN_TOOLTIP: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_RUN_NOW_RUNNING: MvnCodeFE;

  SAFETY_SIGNAL_DETECTION_COL_PRR: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_COL_ROR: MvnCodeFE;

  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_PROFILE_INFO: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_BATCH_RESULT_HISTORY: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_REVIEWER: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_REVIEWER_ASSIGN: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_REVIEWER_ASSIGN_ME: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_HISTORY: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_HISTORY_EMPTY: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_HISTORY_MORE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_STATUS_CHANGE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_REVIEWER_CHANGE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_DUE_DATE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_COL_BATCH_DATE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_COL_PRODUCT_NAME: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_COL_EVENT_TERM: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_COL_COUNT: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_COL_STATUS: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_COL_REVIEWER: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_REVIEWER_NONE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_DRAWER_PRODUCT_EVENT: MvnCodeFE;

  SAFETY_SIGNAL_DETECTION_ASSIGN_REVIEWER_TITLE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_ASSIGN_REVIEWER_SELECT_LABEL: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_ASSIGN_REVIEWER_SELECT_PLACEHOLDER: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_ASSIGN_REVIEWER_DUE_DATE_LABEL: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_ASSIGN_REVIEWER_COMMENT_LABEL: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_ASSIGN_REVIEWER_COMMENT_PLACEHOLDER: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_ASSIGN_REVIEWER_SUCC: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_ASSIGN_REVIEWER_FAIL: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_ASSIGN_ME_TITLE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_UNASSIGN_REVIEWER_TITLE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_UNASSIGN_REVIEWER_CONFIRM_MESSAGE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_UNASSIGN_REVIEWER_SUCC: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_UNASSIGN_REVIEWER_FAIL: MvnCodeFE;

  SAFETY_SIGNAL_DETECTION_CHANGE_STATUS_TITLE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_CHANGE_STATUS_SUCC: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_CHANGE_STATUS_FAIL: MvnCodeFE;

  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_TITLE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_BATCH_DATE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_FILTER_PRODUCT_NAME: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_FILTER_EVENT_TERM: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_COL_ID_NO: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_COL_DETECTION_TYPE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_COL_PRODUCT_NAME: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_COL_EVENT_TERM_PT: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_COL_COUNT: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_COL_CHI_SQUARE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_COL_STATUS: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_COL_ASSIGNEE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_DETECTION_TYPE_NEW: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_DETECTION_TYPE_RE_SIGNALED: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_STATUS_WAIT: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_STATUS_VALIDATED: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_STATUS_REVIEWING: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_STATUS_MONITORING: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_STATUS_REFUTED: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_STATUS_CLOSED: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_EMPTY: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_NO_PROFILE_SELECTED: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_REQUEST_ERROR_TITLE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_REQUEST_ERROR_DESCRIPTION: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_BATCH_DATE_FAILED: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_BATCH_FAILED_TITLE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_BATCH_FAILED_DESCRIPTION: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_FILTER_SEARCH_PLACEHOLDER: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_FILTER_RESET: MvnCodeFE;

  SAFETY_SIGNAL_DETECTION_HEATMAP_DRIFT_NOTICE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_DRILLDOWN_PT_CHANGED: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_DRILLDOWN_CASE_DESTROYED: MvnCodeFE;

  SAFETY_SIGNAL_DETECTION_HEATMAP_TITLE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_HEATMAP_SHOW_PT: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_HEATMAP_CLEAR_SELECTION: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_HEATMAP_METRIC_PRR: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_HEATMAP_METRIC_ROR: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_HEATMAP_LEGEND_TIER_1: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_HEATMAP_LEGEND_TIER_2: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_HEATMAP_LEGEND_TIER_3: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_HEATMAP_LEGEND_TIER_4: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_HEATMAP_LEGEND_LOW_N: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_HEATMAP_LEGEND_NULL_VALUE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_HEATMAP_EMPTY: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_HEATMAP_CASE_LIST_TITLE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_HEATMAP_CASE_LIST_EMPTY_TITLE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_HEATMAP_CASE_LIST_EMPTY_DESCRIPTION: MvnCodeFE;

  SAFETY_SIGNAL_DETECTION_PROFILE_LIST_TITLE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_LIST_EMPTY: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_LIST_SHOW_INACTIVE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_LIST_NO_RUN_HISTORY: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_LIST_TARGET_PRODUCTS_MORE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_DETAIL_PRODUCT_DELETED: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_DETAIL_TARGET_SCOPE_EMPTY: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_PROFILE_DETAIL_TARGET_SCOPE_DELETED_TOOLTIP: MvnCodeFE;

  SAFETY_SIGNAL_DETECTION_REVIEW_PROGRESS_TITLE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_REVIEW_PROGRESS_TAB_RECEIVED: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_REVIEW_PROGRESS_TAB_SENT: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_REVIEW_PROGRESS_SENDER: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_REVIEW_PROGRESS_ASSIGNEE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_REVIEW_PROGRESS_DUE_DATE: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_REVIEW_PROGRESS_EMPTY: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_REVIEW_PROGRESS_EMPTY_RECEIVED: MvnCodeFE;
  SAFETY_SIGNAL_DETECTION_REVIEW_PROGRESS_EMPTY_SENT: MvnCodeFE;
} = {
  SAFETY_SIGNAL_DETECTION_NEW_PROFILE: { ko: "새 프로파일", en: "New Profile" },
  SAFETY_SIGNAL_DETECTION_CREATE: { ko: "생성", en: "Create" },
  SAFETY_SIGNAL_DETECTION_STATUS_ACTIVE: { ko: "활성", en: "Active" },
  SAFETY_SIGNAL_DETECTION_STATUS_INACTIVE: { ko: "비활성", en: "Inactive" },
  SAFETY_SIGNAL_DETECTION_COLUMN_NAME: { ko: "이름", en: "Name" },
  SAFETY_SIGNAL_DETECTION_COLUMN_TARGET_SCOPE: { ko: "분석 대상", en: "Target Scope" },
  SAFETY_SIGNAL_DETECTION_COLUMN_STATUS: { ko: "상태", en: "Status" },
  SAFETY_SIGNAL_DETECTION_COLUMN_RUN_FREQUENCY: { ko: "실행 주기", en: "Run Frequency" },
  SAFETY_SIGNAL_DETECTION_COLUMN_LAST_RUN: { ko: "최근 실행일", en: "Last Run" },
  SAFETY_SIGNAL_DETECTION_COLUMN_NEXT_RUN: { ko: "다음 실행일", en: "Next Run" },
  SAFETY_SIGNAL_DETECTION_EMPTY_TITLE: { ko: "생성된 프로파일이 없습니다.", en: "No profiles have been created." },
  SAFETY_SIGNAL_DETECTION_EMPTY_DESCRIPTION: { ko: "프로파일을 생성해주세요.", en: "Please create a profile." },
  SAFETY_SIGNAL_DETECTION_EMPTY_SEARCH_TITLE: { ko: "검색 결과가 없습니다.", en: "No search results found." },

  SAFETY_SIGNAL_DETECTION_EDIT_PROFILE: { ko: "프로파일 수정", en: "Edit Profile" },

  SAFETY_SIGNAL_DETECTION_PROFILE_CREATE_SUCC: { ko: "프로파일이 생성되었습니다.", en: "Profile has been created." },
  SAFETY_SIGNAL_DETECTION_PROFILE_CREATE_FAIL: {
    ko: "프로파일 생성에 실패했습니다. ({message})",
    en: "Failed to create profile. ({message})",
  },

  SAFETY_SIGNAL_DETECTION_PROFILE_UPDATE_SUCC: { ko: "프로파일이 수정되었습니다.", en: "Profile has been updated." },
  SAFETY_SIGNAL_DETECTION_PROFILE_UPDATE_FAIL: {
    ko: "프로파일 수정에 실패했습니다. ({message})",
    en: "Failed to update profile. ({message})",
  },

  SAFETY_SIGNAL_DETECTION_PROFILE_DELETE_ALERT_TITLE: {
    ko: "프로파일을 삭제하시겠습니까?",
    en: "Do you want to delete this profile?",
  },
  SAFETY_SIGNAL_DETECTION_PROFILE_DELETE_ALERT_DESCRIPTION: {
    ko: "삭제한 항목은 복구할 수 없습니다. 계속하시겠습니까?",
    en: "Deleted items cannot be recovered. Do you want to continue?",
  },
  SAFETY_SIGNAL_DETECTION_PROFILE_DELETE_SUCC: {
    ko: "프로파일이 삭제되었습니다",
    en: "Profile has been deleted.",
  },
  SAFETY_SIGNAL_DETECTION_PROFILE_DELETE_FAIL: {
    ko: "프로파일 삭제에 실패했습니다. ({message})",
    en: "Failed to delete profile. ({message})",
  },

  SAFETY_SIGNAL_DETECTION_PROFILE_INFO_TITLE: { ko: "프로파일 정보", en: "Profile Information" },
  SAFETY_SIGNAL_DETECTION_PROFILE_ACTIVATION_LABEL: { ko: "프로파일 활성화 여부", en: "Profile Activation" },
  SAFETY_SIGNAL_DETECTION_PROFILE_ACTIVATION_ACTIVE: { ko: "활성", en: "Active" },
  SAFETY_SIGNAL_DETECTION_PROFILE_ACTIVATION_INACTIVE: { ko: "비활성", en: "Inactive" },
  SAFETY_SIGNAL_DETECTION_PROFILE_NAME_LABEL: { ko: "프로파일 이름", en: "Profile Name" },
  SAFETY_SIGNAL_DETECTION_PROFILE_NAME_PLACEHOLDER: { ko: "프로파일 이름 입력", en: "Enter profile name" },
  SAFETY_SIGNAL_DETECTION_COMMENT_LABEL: { ko: "코멘트", en: "Comment" },
  SAFETY_SIGNAL_DETECTION_COMMENT_PLACEHOLDER: { ko: "코멘트 입력", en: "Enter comment" },

  SAFETY_SIGNAL_DETECTION_SIGNAL_PREFIX_LABEL: { ko: "프로파일 ID No", en: "Profile ID No" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_PREFIX_PLACEHOLDER: { ko: "프로파일 ID No 입력", en: "Enter Profile ID No" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_PREFIX_INFO_TOOLTIP: {
    ko: "시그널 감지 결과에 사용되는 ID prefix입니다.",
    en: "A unique ID assigned to each signal.",
  },
  SAFETY_SIGNAL_DETECTION_SIGNAL_PREFIX_EXAMPLE_LABEL: { ko: "ID No 예시", en: "ID No Example" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_PREFIX_EXAMPLE_FORMAT: { ko: "{prefix}-1, {prefix}-2...", en: "{prefix}-1, {prefix}-2..." },

  SAFETY_SIGNAL_DETECTION_EXECUTION_START_MONTH_LABEL: { ko: "실행 주기 시작월", en: "Execution Start Month" },
  SAFETY_SIGNAL_DETECTION_EXECUTION_START_MONTH_PLACEHOLDER: { ko: "시작월 선택", en: "Select start month" },

  SAFETY_SIGNAL_DETECTION_TARGET_SCOPE_TITLE: { ko: "분석 대상", en: "Target Scope" },
  SAFETY_SIGNAL_DETECTION_INTERACTION_DRUGS_LABEL: { ko: "상호 작용 약물 포함 여부", en: "Inclusion of Interaction Drugs" },
  SAFETY_SIGNAL_DETECTION_INTERACTION_DRUGS_INCLUDE: { ko: "포함", en: "Include" },
  SAFETY_SIGNAL_DETECTION_TARGET_SCOPE_LABEL: { ko: "분석 대상", en: "Target Scope" },
  SAFETY_SIGNAL_DETECTION_TARGET_SCOPE_PLACEHOLDER: { ko: "분석 대상 선택", en: "Select target scope" },
  SAFETY_SIGNAL_DETECTION_TARGET_PRODUCT_REQUIRED: {
    ko: "분석 대상 약물을 1개 이상 선택해 주세요.",
    en: "Please select at least one target product.",
  },

  SAFETY_SIGNAL_DETECTION_PROFILE_EXECUTION_TITLE: { ko: "프로파일 실행", en: "Profile Execution" },
  SAFETY_SIGNAL_DETECTION_EXECUTION_FREQUENCY_LABEL: { ko: "실행 주기", en: "Execution Frequency" },
  SAFETY_SIGNAL_DETECTION_EXECUTION_FREQUENCY_PLACEHOLDER: { ko: "실행 주기 선택", en: "Select execution frequency" },
  SAFETY_SIGNAL_DETECTION_EXECUTION_DATE_LABEL: { ko: "실행일", en: "Execution Date" },
  SAFETY_SIGNAL_DETECTION_EXECUTION_DATE_PLACEHOLDER: { ko: "실행일 선택", en: "Select execution date" },
  SAFETY_SIGNAL_DETECTION_EXECUTION_TIME_LABEL: { ko: "실행 시각", en: "Execution Time" },
  SAFETY_SIGNAL_DETECTION_EXECUTION_TIME_PLACEHOLDER: { ko: "실행 시간 선택", en: "Select execution time" },
  SAFETY_SIGNAL_DETECTION_EXECUTION_SPECIFIC_DATE_LABEL: { ko: "특정 일자", en: "Specific Date" },
  SAFETY_SIGNAL_DETECTION_EXECUTION_SPECIFIC_DAY_LABEL: { ko: "특정 일자 - 일", en: "Specific Date - Day" },
  SAFETY_SIGNAL_DETECTION_EXECUTION_DAY_PLACEHOLDER: { ko: "일자 선택", en: "Select date" },
  SAFETY_SIGNAL_DETECTION_EXECUTION_DAY_31_HELPER: {
    ko: "해당일이 없는 달은 말일에 실행",
    en: "Runs on the last day for months without this date.",
  },
  SAFETY_SIGNAL_DETECTION_EXECUTION_AD_HOC_HELPER: {
    ko: "이 프로파일은 자동 실행되지 않습니다. Signal Detection 페이지에서 실행 버튼으로 수동 실행할 수 있습니다.",
    en: "This profile does not run automatically. You can manually run it using the run button on the Signal Detection page.",
  },
  SAFETY_SIGNAL_DETECTION_EXECUTION_START_MONTH_REQUIRED_ERROR: {
    ko: "시작월을 선택해주세요.",
    en: "Please select a start month.",
  },
  SAFETY_SIGNAL_DETECTION_EXECUTION_START_MONTH_INVALID_ERROR: {
    ko: "선택할 수 없는 월입니다.",
    en: "This month cannot be selected.",
  },
  SAFETY_SIGNAL_DETECTION_EXECUTION_TIME_REQUIRED_ERROR: {
    ko: "실행 시각을 선택해주세요.",
    en: "Please select an execution time.",
  },
  SAFETY_SIGNAL_DETECTION_EXECUTION_NEXT_RUN_DATE: {
    ko: "실행 예정일",
    en: "Next Run Date",
  },

  SAFETY_SIGNAL_DETECTION_RUN_FREQUENCY_MONTHLY: { ko: "매월", en: "Monthly" },
  SAFETY_SIGNAL_DETECTION_RUN_FREQUENCY_QUARTERLY: { ko: "3개월 마다", en: "Every 3 Months" },
  SAFETY_SIGNAL_DETECTION_RUN_FREQUENCY_ADHOC: { ko: "수동", en: "Ad-Hoc" },

  SAFETY_SIGNAL_DETECTION_RUN_DATE_MONTHLY_FIRST: { ko: "매월 첫날", en: "First day of month" },
  SAFETY_SIGNAL_DETECTION_RUN_DATE_MONTHLY_LAST: { ko: "매월 마지막날", en: "Last day of month" },
  SAFETY_SIGNAL_DETECTION_RUN_DATE_SPECIFIC: { ko: "특정 일자", en: "Specific Date" },

  SAFETY_SIGNAL_DETECTION_RUN_DATE_QUARTERLY_FIRST: { ko: "3개월의 첫날", en: "First day of quarter" },
  SAFETY_SIGNAL_DETECTION_RUN_DATE_QUARTERLY_LAST: { ko: "3개월의 마지막날", en: "Last day of quarter" },

  SAFETY_SIGNAL_DETECTION_STATISTICAL_METHOD_TITLE: { ko: "통계 분석 방법", en: "Statistical Analysis Method" },
  SAFETY_SIGNAL_DETECTION_STATISTICAL_METHOD_LABEL: { ko: "통계 분석 방법", en: "Statistical Analysis Method" },
  SAFETY_SIGNAL_DETECTION_CRITERIA_LABEL: { ko: "Criteria", en: "Criteria" },
  SAFETY_SIGNAL_DETECTION_MIN_REPORT_COUNT_LABEL: { ko: "최소 보고 건수 (N):", en: "Min. Reporting Count (N):" },
  SAFETY_SIGNAL_DETECTION_MIN_PRR_LABEL: { ko: "최소 PRR", en: "Min. PRR" },
  SAFETY_SIGNAL_DETECTION_MIN_ROR_LABEL: { ko: "최소 ROR", en: "Min. ROR" },
  SAFETY_SIGNAL_DETECTION_CHI_SQUARE_LABEL: { ko: "Chi-square", en: "Chi-square" },
  SAFETY_SIGNAL_DETECTION_CUSTOMIZED_CRITERIA_LABEL: { ko: "Customized criteria", en: "Customized criteria" },

  SAFETY_SIGNAL_DETECTION_PROFILE_DETAIL_CLOSE: {
    ko: "닫기",
    en: "Close",
  },
  SAFETY_SIGNAL_DETECTION_PROFILE_SETTINGS_TAB: {
    ko: "프로파일 설정",
    en: "Profile Setting",
  },
  SAFETY_SIGNAL_DETECTION_EXECUTION_HISTORY_TAB: {
    ko: "실행 이력",
    en: "Run History",
  },
  SAFETY_SIGNAL_DETECTION_EXECUTION_HISTORY_EMPTY: {
    ko: "실행 이력이 없습니다.",
    en: "No execution history.",
  },
  SAFETY_SIGNAL_DETECTION_PROFILE_EXECUTED_INFO: {
    ko: "한 번 이상 실행된 프로파일은 프로파일 정보만 수정할 수 있습니다.",
    en: "Only profile information can be modified for profiles that have been executed at least once.",
  },
  SAFETY_SIGNAL_DETECTION_PROFILE_LOAD_FAIL: {
    ko: "프로파일 정보를 불러오지 못했습니다.",
    en: "Failed to load profile information.",
  },

  SAFETY_SIGNAL_DETECTION_RUN_HISTORY_COL_RUN_DATE: { ko: "실행 일자", en: "Run Date" },
  SAFETY_SIGNAL_DETECTION_RUN_HISTORY_COL_RUN_METHOD: { ko: "실행 주기", en: "Run Method" },
  SAFETY_SIGNAL_DETECTION_RUN_HISTORY_COL_RESULT: { ko: "결과", en: "Result" },
  SAFETY_SIGNAL_DETECTION_RUN_HISTORY_COL_SIGNAL_COUNT: { ko: "Signal 수", en: "Signal Count" },
  SAFETY_SIGNAL_DETECTION_RUN_HISTORY_STATUS_IN_PROGRESS: { ko: "진행중", en: "In Progress" },
  SAFETY_SIGNAL_DETECTION_RUN_HISTORY_STATUS_SUCCESS: { ko: "성공", en: "Success" },
  SAFETY_SIGNAL_DETECTION_RUN_HISTORY_STATUS_FAIL: { ko: "실패", en: "Fail" },
  SAFETY_SIGNAL_DETECTION_RUN_HISTORY_STATUS_WAITING: { ko: "대기", en: "Waiting" },
  SAFETY_SIGNAL_DETECTION_RUN_HISTORY_VIEW_RESULT: { ko: "결과보기", en: "View Result" },
  SAFETY_SIGNAL_DETECTION_RUN_HISTORY_FAILED_MESSAGE: {
    ko: "지속 발생시 담당자에게 연락주세요.",
    en: "Please contact if it continues to occur.",
  },

  SAFETY_SIGNAL_DETECTION_PROFILE_DETAIL_TARGET_SCOPE: { ko: "분석 대상", en: "Target Scope" },
  SAFETY_SIGNAL_DETECTION_PROFILE_DETAIL_FREQUENCY: { ko: "주기", en: "Frequency" },
  SAFETY_SIGNAL_DETECTION_PROFILE_DETAIL_STATISTICAL_METHOD: { ko: "통계분석방법", en: "Statistical Analysis Method" },
  SAFETY_SIGNAL_DETECTION_PROFILE_DETAIL_CRITERIA: { ko: "Criteria", en: "Criteria" },
  SAFETY_SIGNAL_DETECTION_PROFILE_DETAIL_RUN_BUTTON: { ko: "프로파일 실행", en: "Run Profile" },
  SAFETY_SIGNAL_DETECTION_PROFILE_RUN_NOW_SUCCESS: { ko: "프로파일 실행이 요청되었습니다", en: "Profile run has been requested" },
  SAFETY_SIGNAL_DETECTION_PROFILE_RUN_NOW_FAIL: {
    ko: "프로파일 실행에 실패했습니다. ({message})",
    en: "Failed to run profile. ({message})",
  },
  SAFETY_SIGNAL_DETECTION_PROFILE_RUN_NOW_COOLDOWN_TOOLTIP: {
    ko: "실행 후 10초 동안은 재실행 할 수 없습니다.",
    en: "Cannot re-run for 10 seconds after execution.",
  },
  SAFETY_SIGNAL_DETECTION_PROFILE_RUN_NOW_RUNNING: { ko: "실행중", en: "Running" },

  SAFETY_SIGNAL_DETECTION_COL_PRR: { ko: "PRR", en: "PRR" },
  SAFETY_SIGNAL_DETECTION_COL_ROR: { ko: "ROR", en: "ROR" },

  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_PROFILE_INFO: { ko: "프로파일 정보", en: "Profile Information" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_BATCH_RESULT_HISTORY: { ko: "Batch Result History", en: "Batch Result History" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_REVIEWER: { ko: "담당자", en: "Reviewer" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_REVIEWER_ASSIGN: { ko: "담당자 지정", en: "Assign Reviewer" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_REVIEWER_ASSIGN_ME: { ko: "나에게 할당", en: "Assign to Me" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_HISTORY: { ko: "히스토리", en: "History" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_HISTORY_EMPTY: { ko: "히스토리가 없습니다.", en: "No history available." },
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_HISTORY_MORE: { ko: "더보기", en: "Load More" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_STATUS_CHANGE: { ko: "상태변경", en: "Status Change" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_REVIEWER_CHANGE: { ko: "담당자 지정", en: "Assign Reviewer" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_DUE_DATE: { ko: "마감일", en: "Due Date" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_COL_BATCH_DATE: { ko: "Batch Date", en: "Batch Date" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_COL_PRODUCT_NAME: { ko: "Product Name", en: "Product Name" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_COL_EVENT_TERM: { ko: "Event Term (PT)", en: "Event Term (PT)" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_COL_COUNT: { ko: "Count", en: "Count" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_COL_STATUS: { ko: "상태", en: "Status" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_COL_REVIEWER: { ko: "담당자", en: "Reviewer" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_REVIEWER_NONE: { ko: "담당자 없음", en: "No Reviewer" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_DETAIL_DRAWER_PRODUCT_EVENT: { ko: "Product name - Event Term", en: "Product name - Event Term" },

  SAFETY_SIGNAL_DETECTION_ASSIGN_REVIEWER_TITLE: { ko: "담당자 지정", en: "Assign Reviewer" },
  SAFETY_SIGNAL_DETECTION_ASSIGN_REVIEWER_SELECT_LABEL: { ko: "담당자", en: "Reviewer" },
  SAFETY_SIGNAL_DETECTION_ASSIGN_REVIEWER_SELECT_PLACEHOLDER: { ko: "담당자 선택", en: "Select reviewer" },
  SAFETY_SIGNAL_DETECTION_ASSIGN_REVIEWER_DUE_DATE_LABEL: { ko: "마감일", en: "Due Date" },
  SAFETY_SIGNAL_DETECTION_ASSIGN_REVIEWER_COMMENT_LABEL: { ko: "코멘트", en: "Comment" },
  SAFETY_SIGNAL_DETECTION_ASSIGN_REVIEWER_COMMENT_PLACEHOLDER: { ko: "코멘트 입력", en: "Enter comment" },
  SAFETY_SIGNAL_DETECTION_ASSIGN_REVIEWER_SUCC: { ko: "담당자가 지정되었습니다.", en: "Reviewer has been assigned." },
  SAFETY_SIGNAL_DETECTION_ASSIGN_REVIEWER_FAIL: { ko: "담당자 지정에 실패했습니다. {message}", en: "Failed to assign reviewer. {message}" },
  SAFETY_SIGNAL_DETECTION_ASSIGN_ME_TITLE: { ko: "나에게 할당", en: "Assign to Me" },
  SAFETY_SIGNAL_DETECTION_UNASSIGN_REVIEWER_TITLE: { ko: "담당자 삭제", en: "Delete Reviewer" },
  SAFETY_SIGNAL_DETECTION_UNASSIGN_REVIEWER_CONFIRM_MESSAGE: {
    ko: "담당자를 삭제하시겠습니까?",
    en: "Are you sure you want to remove the reviewer?",
  },
  SAFETY_SIGNAL_DETECTION_UNASSIGN_REVIEWER_SUCC: { ko: "담당자가 삭제되었습니다.", en: "Reviewer has been removed." },
  SAFETY_SIGNAL_DETECTION_UNASSIGN_REVIEWER_FAIL: {
    ko: "담당자 삭제에 실패했습니다. {message}",
    en: "Failed to remove reviewer. {message}",
  },

  SAFETY_SIGNAL_DETECTION_CHANGE_STATUS_TITLE: { ko: "상태 변경", en: "Change Status" },
  SAFETY_SIGNAL_DETECTION_CHANGE_STATUS_SUCC: { ko: "상태가 변경되었습니다.", en: "Status has been changed." },
  SAFETY_SIGNAL_DETECTION_CHANGE_STATUS_FAIL: { ko: "상태 변경에 실패했습니다. {message}", en: "Failed to change status. {message}" },

  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_TITLE: { ko: "Signal List", en: "Signal List" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_BATCH_DATE: { ko: "Batch Date", en: "Batch Date" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_FILTER_PRODUCT_NAME: { ko: "Product Name", en: "Product Name" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_FILTER_EVENT_TERM: { ko: "Event Term", en: "Event Term" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_COL_ID_NO: { ko: "ID No", en: "ID No" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_COL_DETECTION_TYPE: { ko: "탐지 유형", en: "Detection Type" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_COL_PRODUCT_NAME: { ko: "Product Name", en: "Product Name" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_COL_EVENT_TERM_PT: { ko: "Event Term (PT)", en: "Event Term (PT)" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_COL_COUNT: { ko: "Count", en: "Count" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_COL_CHI_SQUARE: { ko: "Chi-square", en: "Chi-square" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_COL_STATUS: { ko: "상태", en: "Status" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_COL_ASSIGNEE: { ko: "담당자", en: "Reviewer" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_DETECTION_TYPE_NEW: { ko: "신규", en: "New" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_DETECTION_TYPE_RE_SIGNALED: { ko: "재탐지", en: "Re-identified" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_STATUS_WAIT: { ko: "리뷰대기", en: "Pending" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_STATUS_VALIDATED: { ko: "유효", en: "Validated" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_STATUS_REVIEWING: { ko: "검토중", en: "Reviewing" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_STATUS_MONITORING: { ko: "관찰중", en: "Monitoring" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_STATUS_REFUTED: { ko: "기각", en: "Refuted" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_STATUS_CLOSED: { ko: "종결", en: "Closed" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_EMPTY: { ko: "데이터가 없습니다.", en: "No data available." },
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_NO_PROFILE_SELECTED: { ko: "선택된 프로파일이 없습니다.", en: "No profile selected." },
  SAFETY_SIGNAL_DETECTION_PROFILE_REQUEST_ERROR_TITLE: {
    ko: "프로파일 정보 요청을 실패하였습니다.",
    en: "Failed to load profile information.",
  },
  SAFETY_SIGNAL_DETECTION_PROFILE_REQUEST_ERROR_DESCRIPTION: {
    ko: "페이지를 새로고침 해주세요.",
    en: "Please refresh the page.",
  },
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_BATCH_DATE_FAILED: { ko: "실패", en: "Failed" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_BATCH_FAILED_TITLE: { ko: "실행이 실패하였습니다.", en: "Run failed." },
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_BATCH_FAILED_DESCRIPTION: {
    ko: "'프로파일 실행' 버튼으로 다시 시도해주세요.",
    en: "Please try again by clicking the 'Run Profile' button.",
  },
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_FILTER_SEARCH_PLACEHOLDER: { ko: "검색", en: "Search" },
  SAFETY_SIGNAL_DETECTION_SIGNAL_LIST_FILTER_RESET: { ko: "필터 초기화", en: "Reset Filters" },

  SAFETY_SIGNAL_DETECTION_HEATMAP_DRIFT_NOTICE: {
    ko: "MedDRA 버전이 다른 일부 케이스가 포함되어 있습니다. ({count}개 PT)",
    en: "Includes cases classified with different MedDRA versions. ({count} PTs)",
  },
  SAFETY_SIGNAL_DETECTION_DRILLDOWN_PT_CHANGED: {
    ko: "실행 이후 변경됨",
    en: "Changed since run",
  },
  SAFETY_SIGNAL_DETECTION_DRILLDOWN_CASE_DESTROYED: {
    ko: "(삭제됨)",
    en: "(Deleted)",
  },

  SAFETY_SIGNAL_DETECTION_HEATMAP_TITLE: { ko: "Signal Heatmap", en: "Signal Heatmap" },
  SAFETY_SIGNAL_DETECTION_HEATMAP_SHOW_PT: { ko: "PT 표시", en: "Show PT" },
  SAFETY_SIGNAL_DETECTION_HEATMAP_CLEAR_SELECTION: { ko: "선택 해제", en: "Clear selection" },
  SAFETY_SIGNAL_DETECTION_HEATMAP_METRIC_PRR: { ko: "PRR", en: "PRR" },
  SAFETY_SIGNAL_DETECTION_HEATMAP_METRIC_ROR: { ko: "ROR", en: "ROR" },
  SAFETY_SIGNAL_DETECTION_HEATMAP_LEGEND_TIER_1: { ko: "낮음", en: "low" },
  SAFETY_SIGNAL_DETECTION_HEATMAP_LEGEND_TIER_2: { ko: "주의", en: "mild" },
  SAFETY_SIGNAL_DETECTION_HEATMAP_LEGEND_TIER_3: { ko: "경고", en: "elevated" },
  SAFETY_SIGNAL_DETECTION_HEATMAP_LEGEND_TIER_4: { ko: "위험", en: "high" },
  SAFETY_SIGNAL_DETECTION_HEATMAP_LEGEND_LOW_N: { ko: "표본 부족", en: "Low N" },
  SAFETY_SIGNAL_DETECTION_HEATMAP_LEGEND_NULL_VALUE: { ko: "값 산출 불가", en: "No value" },
  SAFETY_SIGNAL_DETECTION_HEATMAP_EMPTY: {
    ko: "표시할 데이터가 없습니다.",
    en: "No data to display.",
  },
  SAFETY_SIGNAL_DETECTION_HEATMAP_CASE_LIST_TITLE: { ko: "Case List", en: "Case List" },
  SAFETY_SIGNAL_DETECTION_HEATMAP_CASE_LIST_EMPTY_TITLE: {
    ko: "선택된 아이템이 없습니다.",
    en: "No item selected.",
  },
  SAFETY_SIGNAL_DETECTION_HEATMAP_CASE_LIST_EMPTY_DESCRIPTION: {
    ko: "히트맵의 아이템을 선택하면 케이스가 표시됩니다.",
    en: "Select a heatmap item to see related cases.",
  },

  SAFETY_SIGNAL_DETECTION_PROFILE_LIST_TITLE: { ko: "프로파일", en: "Profiles" },
  SAFETY_SIGNAL_DETECTION_PROFILE_LIST_EMPTY: { ko: "프로파일이 없습니다.", en: "No profiles found." },
  SAFETY_SIGNAL_DETECTION_PROFILE_LIST_SHOW_INACTIVE: { ko: "비활성 프로파일 표시", en: "Include Inactive Profiles" },
  SAFETY_SIGNAL_DETECTION_PROFILE_LIST_NO_RUN_HISTORY: { ko: "실행 이력 없음", en: "No Run History" },
  SAFETY_SIGNAL_DETECTION_PROFILE_LIST_TARGET_PRODUCTS_MORE: { ko: "외 {count}개", en: "+{count}" },
  SAFETY_SIGNAL_DETECTION_PROFILE_DETAIL_PRODUCT_DELETED: { ko: "(삭제됨)", en: "(Deleted)" },
  SAFETY_SIGNAL_DETECTION_PROFILE_DETAIL_TARGET_SCOPE_EMPTY: { ko: "분석 대상 없음", en: "No target scope" },
  SAFETY_SIGNAL_DETECTION_PROFILE_DETAIL_TARGET_SCOPE_DELETED_TOOLTIP: {
    ko: "워크스페이스에서 삭제된 약물이 있습니다. 삭제된 약물은 분석 대상에서 제외됩니다.",
    en: "Some drugs have been deleted from the workspace. Deleted drugs are excluded from the target scope.",
  },

  SAFETY_SIGNAL_DETECTION_REVIEW_PROGRESS_TITLE: { ko: "리뷰 진행 현황", en: "Review Progress" },
  SAFETY_SIGNAL_DETECTION_REVIEW_PROGRESS_TAB_RECEIVED: { ko: "받은 요청", en: "Received" },
  SAFETY_SIGNAL_DETECTION_REVIEW_PROGRESS_TAB_SENT: { ko: "보낸 요청", en: "Sent" },
  SAFETY_SIGNAL_DETECTION_REVIEW_PROGRESS_SENDER: { ko: "보낸 사람", en: "Sender" },
  SAFETY_SIGNAL_DETECTION_REVIEW_PROGRESS_ASSIGNEE: { ko: "담당자", en: "Assignee" },
  SAFETY_SIGNAL_DETECTION_REVIEW_PROGRESS_DUE_DATE: { ko: "마감일", en: "Due Date" },
  SAFETY_SIGNAL_DETECTION_REVIEW_PROGRESS_EMPTY: { ko: "요청 내역이 없습니다", en: "No requests" },
  SAFETY_SIGNAL_DETECTION_REVIEW_PROGRESS_EMPTY_RECEIVED: { ko: "받은 요청이 없습니다.", en: "No received requests." },
  SAFETY_SIGNAL_DETECTION_REVIEW_PROGRESS_EMPTY_SENT: { ko: "보낸 요청이 없습니다.", en: "No sent requests." },
};

MvnCodeInitiate(SAFETY_SIGNAL_DETECTION_LANG);
